export const MobileIcon = ({ ...props }: any) => (
  <svg width={14} height={17} fill="none" {...props}>
    <path
      stroke="var(--color-icon-bright)"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13 4.75v7.5c0 3-.75 3.75-3.75 3.75h-4.5c-3 0-3.75-.75-3.75-3.75v-7.5C1 1.75 1.75 1 4.75 1h4.5c3 0 3.75.75 3.75 3.75Z"
    />
    <path
      stroke="var(--color-icon-bright)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.499 3.625h-3M6.999 13.825a1.163 1.163 0 1 0 0-2.325 1.163 1.163 0 0 0 0 2.325Z"
    />
  </svg>
);
